import { render, staticRenderFns } from "./zykjyrList.vue?vue&type=template&id=25c8d386&scoped=true&"
import script from "./zykjyrList.vue?vue&type=script&lang=js&"
export * from "./zykjyrList.vue?vue&type=script&lang=js&"
import style0 from "./zykjyrList.vue?vue&type=style&index=0&id=25c8d386&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c8d386",
  null
  
)

export default component.exports